/* NOURKANDI — Liquid theme behaviour
 * Vanilla replacements for the React storefront's motion + interaction layer.
 * Currently: scroll reveals (staggered, IntersectionObserver based).
 */
(function () {
  'use strict';

  function initReveals(root) {
    var targets = (root || document).querySelectorAll('.nk-reveal:not([data-nk-observed])');
    if (!targets.length) return;

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reduce || !('IntersectionObserver' in window)) {
      targets.forEach(function (el) {
        el.setAttribute('data-nk-observed', 'true');
        el.classList.add('nk-reveal--in');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          var delay = parseInt(el.getAttribute('data-nk-delay') || '0', 10);
          window.setTimeout(function () {
            el.classList.add('nk-reveal--in');
          }, delay);
          observer.unobserve(el);
        });
      },
      { rootMargin: '0px 0px -12% 0px', threshold: 0.08 }
    );

    targets.forEach(function (el) {
      el.setAttribute('data-nk-observed', 'true');
      observer.observe(el);
    });
  }

  if (document.readyState !== 'loading') {
    initReveals(document);
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      initReveals(document);
    });
  }

  /* Re-run when the theme editor re-renders a section. */
  document.addEventListener('shopify:section:load', function (event) {
    initReveals(event.target);
  });
})();
